import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { OrganisationService } from '@core/services';

import { Action, Model } from '@shared/models';

export function hasModelActionPermission(model: Model, action: Action): CanActivateFn {
    return (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
        const orgService = inject(OrganisationService);
        const router = inject(Router);
        if (!orgService.userHasPermission(model, action)) {
            return router.createUrlTree(['/forbidden']);
        }
        return true;
    };
}
